shadow$provide[538] = function(require,module,exports) {
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
exports.__esModule = true;
exports.useMathbox = exports.ContainedMathbox = exports.Mathbox = void 0;
__exportStar(require("./components"), exports);
var Mathbox_1 = require("./Mathbox");
__createBinding(exports, Mathbox_1, "default", "Mathbox");
var ContainedMathbox_1 = require("./ContainedMathbox");
__createBinding(exports, ContainedMathbox_1, "default", "ContainedMathbox");
var MathboxAPIContext_1 = require("./MathboxAPIContext");
__createBinding(exports, MathboxAPIContext_1, "useMathbox");
//# sourceMappingURL=index.js.map
};